import React from "react";
import { MobileMenu } from "./MobileMenu";
import { useStickyMenu } from "../../lib/hooks/useStickyMenu";
import { NavMenus } from "./NavMenus";
import { Link } from "react-router-dom";
import { COMPANY } from "../../content/siteContent";
import { ContactNumbers } from "../ContactNumbers/ContactNumbers";

export const HeaderSix = () => {
  // menu sticky
  useStickyMenu();

  return (
    <>
      <div id="header-fixed-height"></div>
      <header className="header-style-six">
        <div className="heder-top-wrap">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-7">
                <div className="header-top-left">
                  <ul className="list-wrap">
                    {/* <li>
                      <i className="flaticon-location"></i>
                      {COMPANY.officeLabel}
                    </li> */}
                    <li>
                      <i className="flaticon-mail"></i>
                      <a href={COMPANY.emailHref}>{COMPANY.email}</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="header-top-right">
                  <ContactNumbers
                    className="header-contact-numbers"
                    showLabels={false}
                  />
                  <div className="header-social">
                    <ul className="list-wrap">
                      <li>
                        <a
                          href="https://www.facebook.com/share/1Axq462wMY/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-facebook-f"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="sticky-header" className="menu-area">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="mobile-nav-toggler">
                  <i className="fas fa-bars"></i>
                </div>
                <div className="menu-wrap">
                  <nav className="menu-nav">
                    <div className="logo">
                      <Link to="/">
                        <img
                          src="/images/logo/logo.png"
                          alt={`${COMPANY.name} logo`}
                        />
                      </Link>
                    </div>

                    {/* nav links */}
                    <NavMenus />

                    <div className="header-action d-none d-md-block">
                      <ul className="list-wrap">
                        <li className="header-btn">
                          <Link to="/contact" className="btn btn-two">
                            Book Appointment
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </nav>
                </div>

                {/* Mobile Menu  */}
                <MobileMenu />
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};
